// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quantity {\n  display: flex;\n  padding: 4px;\n  border: 2px solid #e5e5e5;\n  background-color: rgb(246, 246, 246);\n}\n.quantity-group {\n  width: 80px;\n}\n.card-discount {\n  position: relative;\n}\n.btn-save-discounts {\n  text-align: center;\n  position: sticky;\n  bottom: 0px;\n  left: 0;\n  padding: 0.5rem;\n  background-color: #fffffff7;\n  z-index: 3;\n}\n", ""]);
// Exports
module.exports = exports;
